// Mobile Form Sync - Synchronizes mobile form with variant selections
class MobileFormSync {
  constructor() {
    this.init();
  }

  init() {
    setTimeout(() => {
      this.setupEventListeners();
      this.initializeWithCurrentVariant();
    }, 100);
  }

  updateMobileForm(variantId) {
    const mobileForm = document.getElementById('mobile-product-form');
    if (mobileForm) {
      const mobileInput = mobileForm.querySelector('input[name="id"]');
      if (mobileInput) {
        mobileInput.value = variantId;
      }
    }
  }

  updateMobileButton(variant) {
    const mobileButton = document.querySelector('.mobile-add-cart-btn');
    if (mobileButton && variant) {
      const buttonText = mobileButton.querySelector('.add-to-cart-text');
      if (buttonText) {
        if (variant.available) {
          const price = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(variant.price / 100);
          buttonText.textContent = `Add to Cart - ${price}`;
          mobileButton.disabled = false;
        } else {
          buttonText.textContent = 'Sold out';
          mobileButton.disabled = true;
        }
      }
    }
  }

  getCurrentSelectedVariant() {
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      const selectedVariant = variantSelects.querySelector('[data-selected-variant]');
      if (selectedVariant) {
        try {
          return JSON.parse(selectedVariant.textContent);
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  }

  setupEventListeners() {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.detail && event.detail.variant) {
          this.updateMobileForm(event.detail.variant.id);
          this.updateMobileButton(event.detail.variant);
        }
      });

      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
        setTimeout(() => {
          const variant = this.getCurrentSelectedVariant();
          if (variant) {
            this.updateMobileForm(variant.id);
            this.updateMobileButton(variant);
          }
        }, 200);
      });
    }

    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.addEventListener('change', (event) => {
        setTimeout(() => {
          const variant = this.getCurrentSelectedVariant();
          if (variant) {
            this.updateMobileForm(variant.id);
            this.updateMobileButton(variant);
          }
        }, 200);
      });
    }

    document.addEventListener('change', (event) => {
      const target = event.target;
      
      if (target.name && (target.name.includes('Size') || target.name.includes('Color') || target.name.includes('Option'))) {
        setTimeout(() => {
          const variant = this.getCurrentSelectedVariant();
          if (variant) {
            this.updateMobileForm(variant.id);
            this.updateMobileButton(variant);
          }
        }, 300);
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      
      if (target.type === 'radio' || target.type === 'checkbox') {
        const name = target.name;
        if (name && (name.includes('Size') || name.includes('Color') || name.includes('Option'))) {
          setTimeout(() => {
            const variant = this.getCurrentSelectedVariant();
            if (variant) {
              this.updateMobileForm(variant.id);
              this.updateMobileButton(variant);
            }
          }, 300);
        }
      }
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          const variantSelectsElement = document.querySelector('variant-selects');
          if (variantSelectsElement) {
            const selectedVariant = variantSelectsElement.querySelector('[data-selected-variant]');
            if (selectedVariant && selectedVariant.textContent) {
              try {
                const variant = JSON.parse(selectedVariant.textContent);
                this.updateMobileForm(variant.id);
                this.updateMobileButton(variant);
              } catch (e) {
                // Silent fail
              }
            }
          }
        }
      });
    });

    if (variantSelects) {
      observer.observe(variantSelects, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-selected-variant']
      });
    }
  }

  initializeWithCurrentVariant() {
    setTimeout(() => {
      const variant = this.getCurrentSelectedVariant();
      if (variant) {
        this.updateMobileForm(variant.id);
        this.updateMobileButton(variant);
      }
    }, 500);
  }

  forceUpdate() {
    const variant = this.getCurrentSelectedVariant();
    if (variant) {
      this.updateMobileForm(variant.id);
      this.updateMobileButton(variant);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.mobileFormSync = new MobileFormSync();
}); 